import { AFFILIATE_KAYAK, AFFILIATE_SKYSCANNER } from './affiliates'

export const REDIRECT_EXPERIMENT = {
  ID: 'WEB-5452',
  REDIRECT_TO_SERP: 1,
  REDIRECT_TO_DETAILS: 0,
}

type Query = {
  aid: string | undefined
  offerType: string | undefined
}

const isKayakMultiOffer = (query: Query) =>
  query.aid === AFFILIATE_KAYAK &&
  typeof query.offerType === 'string' &&
  ['multi_offer', 'multi-offer'].includes(query.offerType)

const isSkyScannerBestOffer = (query: Query) =>
  query.aid === AFFILIATE_SKYSCANNER &&
  typeof query.offerType === 'string' &&
  ['best_offer', 'best-offer'].includes(query.offerType)

export const hasToNotifyRedirectExperiment = (query: Query) => {
  return isKayakMultiOffer(query) || isSkyScannerBestOffer(query)
}
